import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import ProductTableOfInformation from '@molecules/ProductTableOfInformation/ProductTableOfInformation';
import ProductTableOfContents from '@molecules/ProductTableOfContents/ProductTableOfContents';
import ProductTableOfOther from '@molecules/ProductTableOfOther/ProductTableOfOther';
import Accordion from '@molecules/Accordion/Accordion';
import AccordionGroup from '@molecules/Accordion/AccordionGroup';
import { useSearchParams } from 'next/navigation';
import type { AxfoodProductDetailsViewModel } from '@occ/api-client';

interface Props {
  data: AxfoodProductDetailsViewModel;
}

const ProductDetailsAccordion = ({ data }: Props) => {
  const searchParams = useSearchParams();
  const queryTab = searchParams?.get('tab') ?? undefined;
  const t = useTranslations('product');
  const [currentOpenedAccordion, setCurrentOpenedAccordion] = useState<string | null>(data.isDrugProduct ? '1' : null);

  const accordionClickHandler = (accordionKey: string) => {
    setCurrentOpenedAccordion(accordionKey === currentOpenedAccordion ? null : accordionKey);
  };
  const renderAccordionGroupTwo = (data: AxfoodProductDetailsViewModel) =>
    data.animalData || data.ingredients || data.nutrientComponents?.length > 0 ? (
      <Accordion enableScroll={queryTab === '2'} accordionKey="2" title={t('tabs.table_of_contents')} key={2}>
        <ProductTableOfContents product={data} />
      </Accordion>
    ) : null;

  useEffect(() => {
    if (data.isDrugProduct) {
      setCurrentOpenedAccordion('1');
    } else if (queryTab && ['1', '2', '3'].includes(queryTab)) {
      setCurrentOpenedAccordion(queryTab);
    } else {
      setCurrentOpenedAccordion(null);
    }
  }, [data, queryTab]);

  return (
    <AccordionGroup currentOpened={currentOpenedAccordion} customClickHandler={accordionClickHandler}>
      <Accordion enableScroll={queryTab === '1'} accordionKey="1" title={t('tabs.product_information')} key={1}>
        <ProductTableOfInformation data={data} />
      </Accordion>
      {renderAccordionGroupTwo(data)}
      <Accordion enableScroll={queryTab === '3'} accordionKey="3" title={t('tabs.other')} key={3}>
        <ProductTableOfOther data={data} />
      </Accordion>
    </AccordionGroup>
  );
};

export default ProductDetailsAccordion;
